<div class="progress-loader" *ngIf="loading$ | async">
	<div class="loader">
		Loading...
	</div>
</div>
